type Term = string;
type Mileage = string;

/*
  e.g
  24: {
  12000: 57,
  15000: 56,
  },
  27: {
  12000: 56,
  15000: 55,
  },...
*/
type MileageMap = Record<Mileage, number>;

export type ResidualPercentages = Record<Term, MileageMap>;

export enum IncentiveType {
  EMPLOYEE = 'employee',
  STUDENT = 'student',
  DISABILITY = 'disability',
  MILITARY = 'military',
  CONQUEST = 'conquest',
  LOYALTY = 'loyalty',
  OTHER = 'other',
}

// Entries of Select Inventory Group IDs, and how many days they start to apply.
// ie: for GroupID 260, after 61 days it begins to apply.
export const SelectInventoryGroupIdsAndDays: Record<number, number> = {
  260: 61,
};
